// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__27GeV","right":"styles_right__1UgVC"};